import { EntityColumnOptions, entityColumn } from "components/UI/Table/columns/entity/entityColumn.tsx";
import { FILTER_TYPES } from "components/UI/Table/constants/filter.ts";
import { TableColumnType } from "components/UI/Table/types/table.ts";

import UserData = App.Data.UserData;

interface AffiliatesColumnOptions<T> extends EntityColumnOptions<T, UserData[]> {
    emptyLabel?: string;
}

export const AffiliatesColumn = <T,>(options: AffiliatesColumnOptions<T>): TableColumnType<T> => {
    const { emptyLabel = "-", ...columnOptions } = options;

    return entityColumn<T, UserData[]>(
        {
            dataIndex: "affiliates",
            key: "affiliates",
            sorter: true,
            filterable: true,
            filterType: FILTER_TYPES.partnerSelect,
            filterName: "affiliates.id",
            sortName: "affiliates.nickname",
            filterIncludeNull: true,
            filterNullOptionLabel: emptyLabel,
            ellipsis: true,
        },
        (affiliates) =>
            affiliates?.length ? affiliates.map((affiliate) => affiliate.nickname).join(", ") : emptyLabel,
        columnOptions
    );
};
